import { render, staticRenderFns } from "./IpoBrokerAccountRowGroup.vue?vue&type=template&id=5dddaf3c"
import script from "./IpoBrokerAccountRowGroup.vue?vue&type=script&lang=js"
export * from "./IpoBrokerAccountRowGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports